import { Link } from "react-router-dom";

const NotFound = () => (
  <section
    className="min-h-[80vh] flex items-center justify-center px-6"
    data-testid="not-found"
  >
    <div className="text-center max-w-xl">
      <p className="text-[10px] font-sans-modern uppercase tracking-[0.3em] text-white/50 mb-6">
        404
      </p>
      <h1 className="font-serif-display text-5xl sm:text-6xl text-white leading-tight">
        This page could not be found.
      </h1>
      <Link
        to="/"
        data-testid="not-found-link"
        className="mt-10 inline-flex items-center justify-center h-12 px-8 bg-white text-[#711457] font-sans-modern font-semibold text-sm tracking-wide hover:bg-slate-200 transition-colors"
      >
        Return home
      </Link>
    </div>
  </section>
);

export default NotFound;
